import { useEffect, useState } from "react";
import { useToast } from "@/components/ui/use-toast"

//import { updateSkillCategoryTags } from "../../api/api";
//import { getUser } from "../../api/authentication";
//import { useAuthContext } from "../../providers/auth_provider";

import { usePrompt } from "@/hooks/usePrompt";

import { Input } from "@/components/ui/input";

import { X, CheckCircle } from "lucide-react";
import { getUserInfo } from "@/lib/api/client-authentication";
import { UserInfo } from "@/lib/types/userInfo";
//import { update } from "lodash";

type CategoryProps = {
	setIsEditTags: any;
	isEditTags: boolean;
	skill: any;
	user: any;
	onUpdate: any;
};

export const Categories = ({
	user,
	setIsEditTags,
	isEditTags,
	skill,
	onUpdate,
}: CategoryProps) => {

	const { toast } = useToast();


	const [member, setMember] = useState<UserInfo>({
		attributes: {
			sub: "",
			email: "",
			given_name: "",
			family_name: "",
			name: "",
		},
		id: "",
		role: "user",
		tier: "free",
		name: "",
		email: "",
		image: "",
	});

	useEffect(() => {
		getUserInfo().then((res) => setMember(res))
	}, [])





	const [tags, setTags] = useState(skill?.categories || []);
	const [showDialog, setShowDialog] = useState<boolean>(false);

	usePrompt(
		"This page has unsaved changes. Do you still wish to leave the page?",
		showDialog
	);


	const handleKeyDown = async (e: any) => {
		if (e.key !== "Enter") return;
		const value = e.target.value;
		if (!value.trim()) return;

		let currentTags = [...tags, value];

		// const toastId = toast({
		// 	title: "Saving...",
		// });


		try {
			const res = await fetch("/api/user/skills/category/tags", { method: "PUT", body: JSON.stringify({ userId: member.id, skillId: skill.id, currentTags }) })
			const result = await res.json()

			// toastId.update(toast({

			// 	variant: "default",
			// 	duration: 1300,
			// 	action: (
			// 	  <div className="w-full flex items-center !ml-0">
			// 		<CheckCircle color="#22c55e" className="mr-2" />
			// 		<span className="text-sm font-semibold">
			// 			Saved
			// 		</span>
			// 	  </div>
			// 	)

			// }));

			setTags(currentTags);
			console.log(currentTags)

		}
		catch (e: any) {
			// toastId.update(toast({
			// 	title: 'Something went wrong',
			// 	duration: 1300,
			// 	description: e.message,
			// 	variant: "destructive"
			// }));

		}
		finally {


			e.target.value = "";
			setShowDialog(false);

		}



	};


	const removeTag = async (index: any) => {

		// const toastId = toast({
		// 	title: "Deleting...",
		// });

		let currentTags = tags.filter((el: any, i: any) => i !== index);

		try {
			const res = await fetch("/api/user/skills/category/tags", { method: "PUT", body: JSON.stringify({ userId: member.id, skillId: skill.id, currentTags }) })
			const result = await res.json()

			// toastId.update(toast({

			// 	variant: "default",
			// 	duration: 1300,
			// 	action: (
			// 	  <div className="w-full flex items-center !ml-0">
			// 		<CheckCircle color="#22c55e" className="mr-2" />
			// 		<span className="text-sm font-semibold">
			// 			Deleted
			// 		</span>
			// 	  </div>
			// 	)

			// }));

			setTags(currentTags);


		}
		catch (e: any) {
			// toastId.update(toast({
			// 	title: 'Something went wrong',
			// 	duration: 1300,
			// 	description: e.message,
			// 	variant: "destructive",

			// }));

		}


	};


	return (
		<div className="py-4 w-full">

			{isEditTags && (
				<Input
					onKeyDown={handleKeyDown}
					onChange={() => setShowDialog(true)}
					placeholder="Type and press enter to add sub-category"
				/>
			)}

			<div className="flex flex-wrap space-y-2 items-end pt-2">

				{tags?.map((tag: any, index: any) =>
				(
					<div
						className="bg-rose-400 p-2 rounded-full mr-2 inline-flex text-white"
						key={index}>
						<span>
							{tag}
						</span>&nbsp;

						{isEditTags && (
							<span
								onClick={() =>
									removeTag(index)
								}>
								<X className="hover:cursor-pointer" />
							</span>
						)}

					</div>
				)
				)}

			</div>

		</div>
	)


}